import { render, staticRenderFns } from "./CheckoutRadio.vue?vue&type=template&id=f652d008"
import script from "./CheckoutRadio.vue?vue&type=script&lang=js"
export * from "./CheckoutRadio.vue?vue&type=script&lang=js"
import style0 from "./CheckoutRadio.vue?vue&type=style&index=0&id=f652d008&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports